<template>
  <vx-card title="Contenido">
    <p>Aquí se puede modificar la información más relevante.</p>

    <div v-if="initProgress" style="          margin-top: 1rem; width: 100%">
      <vs-progress indeterminate color="primary"></vs-progress>
    </div>

    <div class="mt-5">
      <div class="vx-row mb-6">
        <div class="vx-col w-1/3">
          <vs-input @blur="content.email = trimString(content.email)" v-validate="'required'"
                    name="email" class="w-full" label="Email"
                    v-model="content.email"/>
          <span class="text-danger text-sm"
                v-show="errors.has('email')">{{ errors.first('email') }}</span>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-1/3">
          <vs-input @blur="content.apiKey = trimString(content.apiKey)" v-validate="'required'"
                    name="apiKey" class="w-full" label="Api Key"
                    v-model="content.apiKey"/>
          <span class="text-danger text-sm"
                v-show="errors.has('apiKey')">{{ errors.first('apiKey') }}</span>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-1/3">
          <vs-input @blur="content.quoteDocument = trimString(content.quoteDocument)" v-validate="'required'"
                    name="quoteDocument" class="w-full" label="Documento de cotización"
                    v-model="content.quoteDocument"/>
          <span class="text-danger text-sm"
                v-show="errors.has('quoteDocument')">{{ errors.first('quoteDocument') }}</span>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-1/3">
          <vs-input
            name="quoteCount" class="w-full"
            label="Cantidad de cotizaciones"
            disabled
            v-model="quoteCount"/>
        </div>
      </div>

      <div class="flex mt-6 flex-wrap items-center" slot="footer">
        <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid || progress">Guardar</vs-button>
        <div v-if="progress" style="          margin-top: 1rem; width: 100%">
          <vs-progress indeterminate color="primary"></vs-progress>
        </div>
      </div>

    </div>
  </vx-card>
</template>

<script>
import trimString from '../mixins/trimString'

import { auth, db, FieldValue } from '@/firebase/firebaseConfig'

export default {
  name: 'Content',
  mixins: [
    trimString
  ],
  data() {
    return {
      content: {},
      quoteCount: 0,
      progress: false,
      initProgress: false
    }
  },
  /**
   * Get data on firestore
   * @returns {Promise<void>}
   */
  async created() {
    try {
      this.initProgress = true

      // Get counters
      const countDoc = await db.collection('counters').doc('quotes').get()
      this.quoteCount = countDoc.data().count
      // End

      // Gener content
      const querySnap = await db.collection('content').get()

      this.content = {
        id: querySnap.docs[0].id,
        ...querySnap.docs[0].data()
      }
      // End
    } catch (e) {
      this.$vs.notify({
        color: 'warning',
        title: '¡Oh no!',
        text: 'Hubo un error.'
      })
    } finally {
      this.initProgress = false
    }
  },
  computed: {
    isFormValid() {
      return !this.errors.any()
    }
  },
  methods: {
    /**
     *  Save data in firestore
     */
    async submitData() {
      try {
        const result = await this.$validator.validateAll()
        if (result) {
          this.progress = true

          // Content
          let contentRef = db.collection('content').doc(this.content.id)

          //Clone to remove the id
          let cloneContent = Object.assign({}, this.content)
          delete cloneContent.id

          await contentRef.update({
            ...cloneContent,
            uid: auth.currentUser.uid,
            updatedAt: FieldValue.serverTimestamp()
          })

          this.progress = false
          this.$vs.notify({
            color: 'success',
            title: 'Contenido',
            text: 'Contenido modificado correctamente.'
          })
        }
      } catch (e) {
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error.'
        })
      }
    }
  }
}
</script>
